import { OrderTypeEnum } from "../../../../models/ProjectManagement/ProjectManagementBasicDetails";

export const orderTypeFieldsMapping: Record<OrderTypeEnum, string[]> = {
  [OrderTypeEnum.NORMAL]: [
    "PM POC",
    "Sales POC",
    "Payment Status",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Mode Of Payment",
    "Project Notes",
  ],
  [OrderTypeEnum.UNPAID]: [
    "PM POC",
    "Sales POC",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Project Notes",
  ],
  [OrderTypeEnum.EVENT]: [
    "PM POC",
    "Sales POC",
    "Payment Status",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Mode Of Payment",
    "Project Notes",
  ],
  [OrderTypeEnum.STORAGE]: [
    "PM POC",
    "SALES POC",
    "Payment Status",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Mode Of Payment",
    "Project Notes",
  ],
  [OrderTypeEnum.PAID_SAMPLE]: [
    "PM POC",
    "Sales POC",
    "Payment Status",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Mode Of Payment",
    "Project Notes",
  ],
  [OrderTypeEnum.HYBRID]: [
    "PM POC",
    "Sales POC",
    "Payment Status",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Mode Of Payment",
    "Project Notes",
  ],
  [OrderTypeEnum.POD]: [
    "PM POC",
    "Sales POC",
    "Type Of Order",
    "Warehouse",
    "Dispatch Date",
    "Delivery Date",
    "Mode Of Shipment",
    "Type Of Shipment",
    "Flexible Delivery",
    "Project Notes",
  ],
};
